import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import {
  DashboardTitle,
  DashboardText,
  CardHomeContentBodyAction,
  BodyHeader,
  BodyHeaderInfo,
  ContentHeaderSearch,
} from "./styled";

import ContainerAuthenticated from "containers/Authenticated";
import { Row } from "reactstrap";
import Button from "components/Form/Button";
import CampaingTabs from "components/Dashboard/Campaing/Tabs";
import Input from "components/Form/Input";
import "react-datepicker/dist/react-datepicker.css";

import { Load } from "ui/styled";

import styled from "styled-components";
import { parseStrapiImage } from "utils";
import { parseInitialize } from "utils/parsers";
import { ReadAll, SendConfirmationEmail } from "services/users";
import { CoreContext } from "context/CoreContext";
import SuccessToast from "components/Toasts/Success";
import Select from "components/Form/Select";
import { Tooltip } from "@mui/material";

export default function DashboardCampaing() {
  const history = useHistory();
  const navigate = (to) => history.push(`/${to}`);

  const { user } = useContext(CoreContext);

  const [active, setActive] = useState(0);
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [nameFilter, setNameFilter] = useState("");
  const [roleFilter, setRoleFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  const tabs = [
    {
      title: "Backoffice",
      value: 0,
      roles: ["Admin Master", "Gestor"],
    },
    { title: "ForBusiness", value: 1, roles: ["ForBusiness"] },
  ];

  const filterTab = (item) => {
    return tabs?.[active]?.roles.includes(item?.role?.name);
  };

  const filterName = (item) => {
    if (!nameFilter || nameFilter === "") {
      return true;
    }

    return (
      Object.values(item).filter(
        (value) =>
          typeof value === "string" &&
          value.toLowerCase().includes(nameFilter.toLowerCase())
      ).length > 0
    );
  };

  const filterRole = (item) => {
    if (!roleFilter || roleFilter === "") {
      return true;
    }

    return item.role.name === roleFilter;
  };

  const filterStatus = (item) => {
    if (!statusFilter || statusFilter === "") {
      return true;
    }

    const mapper = {
      Confirmado: true,
      Pendente: false,
    };

    return mapper[statusFilter] === item.confirmed;
  };

  const reload = async () => {
    setLoading(true);

    const users = await ReadAll();
    setUsers(users);

    setLoading(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      const users = await ReadAll();

      setUsers(users);

      setLoading(false);
    };

    fetchData();

  }, []);

  return (
    <>
      {user?.role?.name === "Admin Master" && (
        <ContainerAuthenticated side={2}>
          {!loading ? null : <Load colored centred />}
          <BodyHeader>
            <BodyHeaderInfo>
              <DashboardTitle small={true}>Usuários</DashboardTitle>
              <DashboardText>
                Convide usuários para fazer a gestão de campanhas.
              </DashboardText>
            </BodyHeaderInfo>
            <CardHomeContentBodyAction>
              <Button
                onClick={() => navigate("dashboard/users/create")}
                primary
              >
                + CONVIDAR USUÁRIOS
              </Button>
            </CardHomeContentBodyAction>
          </BodyHeader>
          <div style={{ display: "flex", justifyContent: "space-between", paddingTop: "20px" }}>
            <ContentHeaderSearch>
              <Input
                withSearch
                rounded
                placeholder="Buscar usuários"
                value={nameFilter}
                onChange={(e) => setNameFilter(e.target.value)}
              />
            </ContentHeaderSearch>

            <div
              style={{
                marginLeft: "20px",
                width: "25%",
                borderRadius: "8px",
              }}
            >
              <Select
                backgroundColor="#FFFFFF"
                labelMargin="0"
                labelPadding="0"
                label="Tipo de permissão"
                placeholder="Tipo de permissão"
                options={[
                  { id: "Admin Master", title: "Admin Master" },
                  { id: "Gestor", title: "Gestor" },
                  { id: "ForBusiness", title: "ForBusiness" },
                ]}
                value={roleFilter}
                onChange={(val) => setRoleFilter(val)}
              />
            </div>

            <div
              style={{
                marginLeft: "20px",
                width: "25%",
                borderRadius: "8px",
              }}
            >
              <Select
                backgroundColor="#FFFFFF"
                labelMargin="0"
                labelPadding="0"
                label="Status"
                placeholder="Status"
                options={[
                  { id: "Confirmado", title: "Confirmado" },
                  { id: "Pendente", title: "Pendente" },
                ]}
                value={statusFilter}
                onChange={(val) => setStatusFilter(val)}
              />
            </div>
          </div>

          <CampaingTabs tabs={tabs} active={active} setActive={setActive} />

          {users
            ?.filter(filterTab)
            ?.filter(filterName)
            ?.filter(filterRole)
            ?.filter(filterStatus)
            ?.map((item, index, array) => (
              <Row key={item.id}>
                <CardDashboardUser
                  user={item}
                  setUsers={setUsers}
                  setLoading={setLoading}
                  isFirst={index === 0}
                  isLast={index === array.length - 1}
                />
              </Row>
            ))}
        </ContainerAuthenticated>
      )}
    </>
  );
}

function CardDashboardUser({ user, setUsers, setLoading, isFirst, isLast }) {
  const { setModal } = useContext(CoreContext);
  const history = useHistory();
  const navigate = (to) => history.push(`/${to}`);

  const reload = async () => {
    setLoading(true);

    const users = await ReadAll();
    setUsers(users);

    setLoading(false);
  };

  const resendConfirmationEmail = async () => {
    await SendConfirmationEmail({ email: user.email });

    SuccessToast({ message: "Convite reenviado com sucesso" });
  };

  return (
    <>
      <CardHomeContent isFirst={isFirst} isLast={isLast}>
        <CardHomeContentBody >
          <div
            style={{
              display: "flex",

            }}
          >
            <CardDashboardCampaignUserImage
              image={user.image?.url ? parseStrapiImage(user.image?.url) : null}
            >
              <CardDashboardCampaignUserImageText>
                {user.image?.url ? null : parseInitialize(user.name)}
              </CardDashboardCampaignUserImageText>
            </CardDashboardCampaignUserImage>
            <div
              style={{
                width: "300px",
              }}
            >
              <CardHomeContentBodyTitle>{user.name}</CardHomeContentBodyTitle>
              <CardHomeContentBodyText>{user.email}</CardHomeContentBodyText>
            </div>
          </div>
          <div style={{
            width: "150px",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}>
            <CardHomeContentBodyTitle>{"Permissão"}</CardHomeContentBodyTitle>
            <CardHomeContentBodyText>{user.role.name}</CardHomeContentBodyText>
          </div>
          <div style={{ display: "flex", gap: "10px", width: "200px", justifyContent: "flex-end" }}>
            <CardHomeContentLabel isSuccess={user.confirmed}>
              <CardHomeContentLabelDecoration isSuccess={user.confirmed} />
              <CardHomeContentLabelText isSuccess={user.confirmed}>
                {user.confirmed ? "Confirmado" : "Pendente"}
              </CardHomeContentLabelText>
            </CardHomeContentLabel>
            <Tooltip
              title="Editar usuário"
            >
              <CardDashboardCampaignEditIcon
                onClick={() => navigate(`dashboard/users/edit/${user.id}`)}
              />
            </Tooltip>
            {!user.confirmed && (
              <>
                <Tooltip
                  title="Reenviar convite"
                >
                  <CardDashboardCampaignResendIcon
                    onClick={resendConfirmationEmail}
                  />
                </Tooltip>

              </>
            )}
            <Tooltip
              title="Deletar usuário"
            >
              <CardDashboardCampaignTrashIcon

                onClick={() =>
                  setModal({ type: "delete-user", item: user, reload })
                }
              />
            </Tooltip>

          </div>
        </CardHomeContentBody>
      </CardHomeContent>
    </>
  );
}

const CardHomeContent = styled.div`
  width: 100%;
  padding: 16px 24px;
  background: ${(props) => props.theme.palette.colors.white};
  border-bottom: ${(props) => props.theme.palette.colors.disabledgrey} 1px solid;
  border-radius: 0;

  ${({ isFirst }) => isFirst && `
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  `}

  /* Última div: arredondar canto inferior */
  ${({ isLast }) => isLast && `
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  `}
  

`;



const CardHomeContentLabel = styled.div.attrs({})`
  padding: 4px 16px 4px 8px;
  background: ${(props) =>
    props.isSuccess
      ? props.theme.palette.colors.greenLight
      : props.theme.palette.colors.purpleLight};
  border-radius: 32px;
  display: flex;
  align-items: center;
  
`;
const CardHomeContentLabelDecoration = styled.img.attrs((props) => ({
  src: props.isSuccess ? "/icons/approved.svg" : "/icons/info.svg",
}))`
  width: 13px;
  height: 13px;
  margin: 0 8px 0 0;
`;
export const CardHomeContentLabelText = styled.div.attrs({})`
  font-size: 14px;
  color: ${(props) =>
    props.isSuccess
      ? props.theme.palette.colors.green
      : props.theme.palette.colors.blue};
`;
export const CardHomeContentBody = styled.div.attrs({})`
  display: flex;
  align-items: center;
  justify-content: space-between;

  

  
`;
export const CardHomeContentBodyTitle = styled.div`
  font-size: 18px;
  color: ${(props) => props.theme.palette.colors.black};
  margin-left: 20px;
  width: 100%;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1; /* Limita a uma linha antes de truncar */
  text-overflow: ellipsis;
`;

export const CardHomeContentBodyText = styled.div.attrs({})`
  font-size: 14px;
  color: ${(props) => props.theme.palette.colors.text};
  margin: 8px 0 5px 20px;
`;
export const CardHomeContentBodyActions = styled.div.attrs({})`
  padding: 8px 0 0;
  display: flex;
`;
export const CardDashboardCampaignEditIcon = styled.img.attrs({
  src: "/icons/edit.svg",
  width: 18,
})`
  &:hover {
    cursor: pointer;
  }
`;
export const CardDashboardCampaignResendIcon = styled.img.attrs({
  src: "/icons/resend.svg",
  width: 18,
})`
  &:hover {
    cursor: pointer;
  }
`;
export const CardDashboardCampaignTrashIcon = styled.img.attrs({
  src: "/icons/trash-2.svg",
  width: 16,
})`
  &:hover {
    cursor: pointer;
  }
`;
export const CardDashboardCampaignMoreDetails = styled.div.attrs({})`
  margin-left: 25px;
  margin-right: 25px;

  color: ${(props) => props.theme.palette.secondary.main};
  &:hover {
    cursor: pointer;
  }
`;
export const CardDashboardCampaignUserImage = styled.div.attrs({})`
  width: 56px;
  height: 56px;
  border-radius: 28px;

  background: ${(p) => p.theme.palette.colors.lightprimary}
    url(${(p) => p.image}) no-repeat center center / cover;

  display: flex;
  align-items: center;
  justify-content: center;
`;
export const CardDashboardCampaignUserImageText = styled.div.attrs({})`
  font-size: 24px;
  color: ${(p) => p.theme.palette.colors.text};
`;
